import { UserEntity, UserType } from "@/domain/entities";

import { formatCurrency, formatPhone } from "@/utils/Helper";
import moment from "moment";
import { formatCPF } from "../../utils/Helper";
import { BasePartnership } from "./BasePartnership";
import { Role } from "../permissions/permissions.types";

export class User {
  id: string;
  name: string = "";
  email: string = "";
  createdAt: string;
  phone: string = "";
  type: UserType
  is_admin: boolean
  document_number: string = "";
  balance: string;
  sessions_count: number;
  partnership_id: string | null;
  partnership: BasePartnership | null = null
  profile_image: string
  role: Role
  address?: {
    street: string;
    city: string;
    state: string;
  };

  constructor(user: UserEntity) {

    const getProfileImage = () => {
      if (this.partnership) return this.partnership.logo
      return require("@/presentation/assets/img/logo-square.svg")
    }
    const getRole = (): Role => {
      if (!this.partnership_id) return 'admin'
      if (this.partnership?.is_third_party_infra) return 'third_party_partner'
      return 'greezon_partner'
    }

    this.id = user.id;
    this.balance = formatCurrency(user.balance);
    this.sessions_count = user.sessions_count;
    this.createdAt = moment(user.created_at).format("DD/MM/YYYY");

    if (user.name) {
      this.name = user.name;
    }
    if (user.email) {
      this.email = user.email;
    }
    if (user.phone) {
      this.phone = formatPhone(user.phone);
    }
    if (user.document_number) {
      this.document_number = formatCPF(user.document_number);
    }
    if (user.address) {
      this.address = {
        street: user.address.line_1,
        city: user.address.city,
        state: user.address.state,
      };
    }

    this.type = user.type
    this.is_admin = this.type === UserType.admin
    this.partnership_id = user.partnership_id
    if (user.partnership) {
      this.partnership = new BasePartnership(user.partnership)
    }

    this.profile_image = getProfileImage()
    this.role = getRole()
    console.log('role', this.role)

  }

  static empty = {
    id: "",
    name: "",
    email: "",
    createdAt: "",
    phone: "",
    document_number: "",
    balance: "",
    sessions_count: 0,
  };

  static emptyAdminForm = {
    name: "",
    email: "",
    type: "admin",
  };
}
